import React, { useState, useEffect, useCallback } from 'react';

export default function StarRating({ average, count, myScore, onRate, canRate }) {
  const [hovered, setHovered] = useState(0);
  const [flash, setFlash] = useState(null);

  const displayScore = average || 0;
  const isHovering = canRate && hovered > 0;

  useEffect(() => {
    if (flash) {
      const t = setTimeout(() => setFlash(null), 1500);
      return () => clearTimeout(t);
    }
  }, [flash]);

  const handleClick = useCallback((score) => {
    setFlash(score);
    setHovered(0);
    onRate(score);
  }, [onRate]);

  const renderStars = () => {
    const fullStars = Math.floor(displayScore);
    const fraction = displayScore - fullStars;

    return [1, 2, 3, 4, 5].map(i => {
      let fill;
      if (isHovering) {
        fill = i <= hovered ? 100 : 0;
      } else {
        if (i <= fullStars) fill = 100;
        else if (i === fullStars + 1) fill = Math.round(fraction * 100);
        else fill = 0;
      }

      return (
        <span
          key={i}
          className={`star-item${canRate ? ' star-clickable' : ''}`}
          onMouseEnter={canRate ? () => setHovered(i) : undefined}
          onMouseLeave={canRate ? () => setHovered(0) : undefined}
          onClick={canRate ? () => handleClick(i) : undefined}
        >
          <span className="star-bg">★</span>
          <span className="star-fill" style={{ width: `${fill}%` }}>★</span>
        </span>
      );
    });
  };

  return (
    <div className="star-rating">
      {renderStars()}
      <span className="star-rating-avg">{displayScore > 0 ? displayScore.toFixed(1) : '–'}</span>
      <span className="star-rating-count">({count} {count === 1 ? 'vote' : 'votes'})</span>
      {flash && <span className="star-rating-flash">You rated {flash}★</span>}
      {!flash && myScore && <span className="star-rating-yours">· You: {myScore}★</span>}
    </div>
  );
}
